/**
 * Detects if the device has touch capability.
 * This is used to prevent double-tap issues on mobile Safari and other touch devices
 * where hover states interfere with click events.
 *
 * @returns true if the device supports touch events
 */
const isTouchDevice = (): boolean => {
  if (typeof window === 'undefined') return false
  return 'ontouchstart' in window || (navigator?.maxTouchPoints ?? 0) > 0
}

export default isTouchDevice
